<div mat-dialog-title class="customer-entrance-header">
  <div class="customer-entrance-header-data">
    @if (org().compactLogoLink) {
      <img src="{{ org().compactLogoLink }}" class="customer-entrance-header-data__image" alt="Logo for {{ org().name }}" />
    } @else {
      <svg class="icon-64" aria-hidden="false" aria-label="Organisationsikon">
        <use href="assets/images/ok-icons-sprite.svg#building-l"></use>
      </svg>
    }
    <div class="customer-entrance-header-data__info">
      <div class="customer-entrance-header-data__title-row">
        <h3 class="customer-entrance-header-data__name">{{ org().name }}</h3>
        <div class="customer-entrance-header-data__actions">
          <button
            matTooltip="Imiter {{ org().name }} på {{ publicPortalName }}"
            class="customer-entrance-header-data__imitate-button"
            matIconButton
            (click)="imitateOrganization()"
            aria-label="Imitér {{ org().name }}">
            <svg class="icon-32" aria-hidden="false" aria-label="Imitér">
              <use href="assets/images/ok-icons-sprite.svg#users-s"></use>
            </svg>
          </button>
          <button matIconButton [matMenuTriggerFor]="menu" aria-label="Menu for {{ org().name }}">
            <svg class="icon-32" aria-hidden="false">
              <use href="assets/images/ok-icons-sprite.svg#dots-s"></use>
            </svg>
          </button>
        </div>
        <mat-menu #menu="matMenu">
          @for (item of menuItems; track item.key) {
            @if (!item.hiddenFn()) {
              <button mat-menu-item (click)="item.action(org())">
                @if (item.svgIcon) {
                  <mat-icon [svgIcon]="item.svgIcon"></mat-icon>
                } @else if (item.materialIcon) {
                  <mat-icon>{{ item.materialIcon }}</mat-icon>
                } @else if (item.spriteIcon) {
                  <svg class="icon-24"><use [attr.href]="'assets/images/ok-icons-sprite.svg#' + item.spriteIcon"></use></svg>
                }
                <span>{{ item.label }}</span>
              </button>
            }
          }
        </mat-menu>
      </div>
      <div class="customer-entrance-header-data__details">
        <span>{{ translateOrganizationType(org().organizationType) }}</span>
        <span><strong>G4 kundenr.:</strong> {{ org().identification }}</span>
        <span><strong>ID Tag gruppe:</strong> {{ org().idTagGroupName }}</span>
      </div>
    </div>
  </div>
  <div class="customer-entrance-header__search">
    <adm-org-typeahead (itemSelected)="onOrgSelected($event)" [resetTrigger]="typeaheadResetTrigger()" />
  </div>

  <button class="customer-entrance-header__close" mat-dialog-close type="button" (click)="closeDialog()">
    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
  </button>
</div>
<div class="customer-entrance-content" mat-dialog-content>
  @if (departmentsLoaded()) {
    @if (tabs().length > 0) {
      <ok-tabs [tabs]="tabs()" />
    } @else {
      <ok-feedback-fail> Der er ingen data at vise for denne organisation.</ok-feedback-fail>
    }
  }
</div>

<ng-template matTabContent #departmentsContent>
  <adm-tab-departments [organization]="org()" (closeDialogRequested)="closeDialog()" />
</ng-template>

<ng-template matTabContent #locationsContent>
  <adm-tab-locations [organization]="org()" />
</ng-template>
